import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import thunk from 'redux-thunk'
import { reducer as form } from 'redux-form'
import { routerMiddleware, connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'

// Reducers
import budget from './modules/budget/reducer'
import homes from './modules/homes/reducer'
import url from './modules/url/reducer'
import session from './modules/session/reducer'
import properties from './modules/properties/reducer'
import auth from './modules/auth/reducer'
import onboardings from './modules/onboardings/reducer'
import userTasks from './modules/user-tasks/reducer'
import schedule from './modules/schedule/reducer'
import priorityRentals from './modules/priority-rentals/reducer'

// Workers
import urlWorker from './workers/url'
import sessionWorker from './workers/session'
import authWorker from './workers/auth'
import whitelistedPropertiesWorker from './workers/whitelisted-properties'
import onboardingsWorker from './workers/onboardings'
import firebaseUserWorker from './workers/firebase-user'
import userTasksWorker from './workers/user-tasks'
import viewingRequestsWorker from './workers/viewing-requests'
import cookieUser from './workers/cookie-user'

export const history = createBrowserHistory()

const appReducer = combineReducers({
  form,
  budget,
  homes,
  url,
  session,
  properties,
  auth,
  onboardings,
  userTasks,
  schedule,
  priorityRentals,
  router: connectRouter(history)
})

export default function rootReducer (state, action) {
  return appReducer(state, action)
}

const middlewares = [
  thunk,
  urlWorker,
  sessionWorker,
  authWorker,
  whitelistedPropertiesWorker,
  onboardingsWorker,
  firebaseUserWorker,
  userTasksWorker,
  viewingRequestsWorker,
  cookieUser,
  routerMiddleware(history)
].filter(Boolean)

/* eslint-disable no-underscore-dangle */
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
/* eslint-enable */

export const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(...middlewares)
  )
)
